<div class="w-100" #dialogContent>
    <div class="move-mails">
        <form [formGroup]="moreFilterForm" (ngSubmit)="confirmApply()">
            <div class="row align-items-center">
                <div class="col-3 pt-20">From Email</div>
                <div class="col-9 ps-0">
                    <div class="tagus-form-group without-icon w-100">
                        <app-chip-input label=" " placeholder=" " [formControl]="formControls.fromMail"
                            [suggestions]="[]" [maxLimit]="1"></app-chip-input>
                    </div>
                </div>
            </div>
            <div class="row align-items-center mt-20" *ngIf="isAdmin">
                <div class="col-3 pt-20">Recipient Mail</div>
                <div class="col-9 ps-0">
                    <mat-form-field class="w-100">
                        <mat-select formControlName="receiptMailId" class="border-b-1 p-0">
                            <ng-container *ngFor="let recipinet of recipientMailList">
                                <mat-option [value]="recipinet?.mail">{{recipinet?.mail}}</mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="row align-items-center mt-20">
                <div class="col-3 pt-20">From Name</div>
                <div class="col-9 ps-0">
                    <div class="tagus-form-group without-icon w-100">
                        <mat-form-field appearance="fill" class="w-100">
                            <input matInput formControlName="fromName">
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <div class="row align-items-center mt-20">
                <div class="col-3 pt-20">Subject</div>
                <div class="col-9 ps-0">
                    <div class="tagus-form-group without-icon w-100">
                        <mat-form-field appearance="fill" class="w-100">
                            <input matInput formControlName="subject">
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <div class="row align-items-center mt-20 pt-20">
                <div class="col-6">
                    <mat-label>Allow for Existing Mails?</mat-label>
                    <br />
                    <mat-radio-group formControlName="existingMails">
                        <mat-radio-button [value]="true">Yes</mat-radio-button>
                        <mat-radio-button [value]="false">No</mat-radio-button>
                    </mat-radio-group>
                </div>
                <div class="col-6 ps-0">
                    <div class="row">
                        <div class="col-6">
                            <mat-label>Read Mails?</mat-label>
                            <br />
                            <mat-radio-group formControlName="isRead">
                                <mat-radio-button [value]="true">Yes</mat-radio-button>
                                <mat-radio-button [value]="false">No</mat-radio-button>
                            </mat-radio-group>
                        </div>

                        <div class="col-6" *ngIf="isAdmin">
                            <mat-label>Global Rule?</mat-label>
                            <br />
                            <mat-radio-group formControlName="isAdmin">
                                <mat-radio-button [value]="true">Yes</mat-radio-button>
                                <mat-radio-button [value]="false">No</mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>

                </div>
            </div>
            <ng-container *ngIf="formControls.existingMails.value">
                <div class="row align-items-center mt-20">
                    <div class="col-3 pt-20">Start Date</div>
                    <div class="col-9 ps-0">
                        <div class="tagus-form-group without-icon w-100">
                            <app-datepicker [control]="formControls?.startDate" label=""></app-datepicker>
                        </div>
                    </div>
                </div>
                <div class="row align-items-center mt-20">
                    <div class="col-3 pt-20">End Date</div>
                    <div class="col-9 ps-0">
                        <div class="tagus-form-group without-icon w-100">
                            <app-datepicker [control]="formControls?.endDate" label=""></app-datepicker>
                        </div>
                    </div>
                </div>
            </ng-container>

            <div class="row align-items-center mt-20">
                <div class="col-3 pt-15">Move To</div>
                <div class="col-9 ps-0">
                    <mat-form-field class="w-100">
                        <mat-select formControlName="moveTo" class="border-b-1 p-0">
                            <mat-option [value]="MailTypeIds?.archived">Done</mat-option>
                            <mat-option [value]="MailTypeIds?.junk">Junk</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="row gap-x-4 align-items-center justify-content-end mt-20 pb-20 px-2">
                <button type="button" mat-stroked-button color="accent" *ngIf="isEdit" (click)="resetForm(); isEdit= false;">Cancel Edit</button>
                <button type="button" mat-raised-button color="warn" (click)="resetForm()">Reset Form</button>
                <button type="submit" mat-raised-button color="primary">Apply</button>
            </div>
        </form>
    </div>
    <div class="mail-rule-container position-relative">
        <h4>Added Mail Rule List</h4>
        <app-move-mails-list [mailRuleList]="mailRuleList" (onEdit)="editRule($event)"
            (onDeleteRule)="deleteRule($event)"></app-move-mails-list>
            <app-global-paginator [length]="pagination_config.total" (globalPageChange)="pagination($event)">
            </app-global-paginator>
        <div *ngIf="showLoader" class="mail-rule-loader">
            <mat-spinner class="small-spinner"></mat-spinner>
        </div>
    </div>
</div>